/* Derived view-model for the faq route.
 * Ported from the artifact's vals_faq(), which closed over component state and
 * so could not be generated mechanically. */
import { useCallback, useState } from 'react';
import { FOOTER_COLS } from '@/data/wft';
import { FAQ } from '@/data/faq';

export function useFaqVals() {
  // -1 means every entry is collapsed.
  const [open, setOpen] = useState(-1);

  const toggle = useCallback((i: number) => {
    setOpen((current) => (current === i ? -1 : i));
  }, []);

  return {
    footerCols: FOOTER_COLS,
    faq: FAQ.map((f, i) => ({
      q: f.q,
      a: f.a,
      tag: f.tag,
      marker: open === i ? '—' : '+',
      open: open === i,
      // Typed as the literal union so it satisfies React's Booleanish for
      // aria-expanded rather than widening to string.
      openStr: (open === i ? 'true' : 'false') as 'true' | 'false',
      toggle: () => toggle(i),
    })),
  };
}

export type FaqVals = ReturnType<typeof useFaqVals>;
